export default Object.freeze({
  getMessages: {
    GET: () => {
      return `suggestions/suggestions/`;
    },
  },
});
